<template>
  <div class="item-detail" v-if="item">
    <van-cell value-class="value-class" size="mini" :value="'应付' + price(item.payAmount - item.balancePayAmt)">
      <van-button v-if="item.paid" slot="right-icon" type="primary" size="mini">已支付</van-button>
      <van-button v-else slot="right-icon" type="primary" size="mini" @click="toPay">去付款</van-button>
    </van-cell>
    <van-cell use-slot title="帐期:" size="mini" :value="billDate"/>
    <van-cell use-slot title="总金额:" size="mini" :value="price(item.totalAmount)"/>
    <van-cell use-slot title="优惠金额:" size="mini" :value="price(item.discountAmount)"/>
    <van-cell use-slot title="应付金额:" size="mini" :value="price(item.payAmount)"/>
    <van-cell use-slot title="余额抵扣金额:" size="mini" :value="price(item.balancePayAmt)"/>
    <van-cell use-slot title="订单数:" size="mini" :value="item.tradeNum"/>
    <div class="detail-list">
      <div class="detail-list-title">
        帐单明细
      </div>
      <div class="detail-list-content">
        <van-card v-for="trade in trades" :key="trade.id" style="background-color: #FFF;"
                  :num="trade.orders.length"
                  :price="price2(trade.payAmount)"
                  :desc="names(trade.orders)"
                  :title="patientInfo(trade.patient)"
        />
      </div>
    </div>
    <div class="bottom-btn">
      <van-button v-show="hasNext" type="info" block size="small" :loading="loading" color="#21AEC3" @click="nextPage">
        下一页
      </van-button>
    </div>
  </div>
</template>
<script>
import {billPayParam, getClinicBill, tradeList, weChatGetTicked} from "@/api";
import {mapState} from "vuex";
import moment from 'moment'
import wx from "weixin-js-sdk";

export default {
  name: "orderDetail",
  components: {},
  data() {
    return {
      id: null,
      item: undefined,
      from: undefined,
      to: undefined,
      page: 1,
      hasNext: true,
      loading: false,
      trades: []
    }
  },
  computed: {
    ...mapState({
      tokenInfo: "tokenInfo",
    }),
    billDate() {
      if (this.item) {
        return moment(this.item.billFrom).format('YYYY-MM-DD') + '~' + moment(this.item.billTo).format('YYYY-MM-DD')
      }
      return ""
    }
  },
  mounted() {
    if (this.$route.query.billId) {
      this.id = parseInt(this.$route.query.billId)
      getClinicBill({
        id: this.id
      }).then(res => {
        this.item = res
        this.from = res.billFrom
        this.to = res.billTo
        this.getTrades(this.page)
      })
    } else {
      this.$toast("数据加载错误，请稍后重试");
    }
  },
  destroy() {
  },
  methods: {
    nextPage() {
      if (!this.loading) {
        this.getTrades(this.page)
      }
    },
    getTrades(page) {
      this.loading = true
      tradeList({
        authTimeFrom: this.from,
        authTimeTo: this.to,
        settleMethod: '2',
        queryPaidStatus: true,
        clinicId: this.tokenInfo.user.clinic.id,
        page: page,
        size: 10,
      }).then(res => {
        console.log(res.data)
        if (res.data && res.data.length > 0) {
          this.hasNext = true
          this.page = this.page + 1
          this.trades.push(...res.data)
        } else {
          this.hasNext = false
        }
        this.loading = false
      }).catch(() => this.loading = false)
    },
    names(orders) {
      return orders.map(t => t.name).join(',')
    },
    price(v) {
      return '￥' + (v / 100).toFixed(2)
    },
    price2(v) {
      return (v / 100).toFixed(2)
    },
    patientInfo(patient) {
      const sex = patient.sex === 'F' ? '女' : '男'
      return `${patient.name}(${sex})`
    },
    toPay() {
      console.log('帐单ID', this.id)
      billPayParam({id: parseInt(this.id)}).then(res => {
        this.authorize(res)
      })
    },
    authorize(params) {
      const redirect_uri = window.location.href.split('#')[0]
      weChatGetTicked({
        url: redirect_uri
      }).then(res => {
        const {appId, timestamp, noncestr, signature} = res
        wx.config({
          debug: false,
          appId: appId,
          timestamp: timestamp,
          nonceStr: `${noncestr}`,
          signature: signature,
          jsApiList: ['chooseWXPay']
        })
        wx.ready(res => {
          wx.checkJsApi({/*检查微信支付是否验证通过*/
            jsApiList: ['chooseWXPay'],
            success: res => {
              /*微信支付*/
              wx.chooseWXPay({
                appId: params.appId,
                timestamp: params.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: params.nonceStr, // 支付签名随机串，不长于 32 位
                package: params.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: params.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: params.paySign, // 支付签名
                success: function () {
                  this.$toast('支付成功')
                },
                cancel: function (res) {
                  this.$toast('您取消了支付')
                }
              });
            },
            fail: err => {
              console.log('check api fail:', err)
            }
          })
        })
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.value-class {
  color: #21AEC3;
}

.item-detail {
  position: relative;
  margin-bottom: 35px;

.item-summary {
  padding: 0.625rem 1rem;
  color: #323233;
  font-size: 0.875rem;
  line-height: 1.5rem;
  background-color: #fff;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
}

}
.detail-list {

.detail-list-title {
  padding: 1rem 1rem 0.5rem 2rem;;
  color: #969799;
  font-size: 0.875rem;
  line-height: 1rem;
}

.detail-list-content {
  margin: 0 1rem;
  border-radius: 0.5rem;
}

}
.bottom-btn {
  margin: 0 1rem;
}

.van-panel__header-value {
  color: #21AEC3;
}
</style>
